import { IntlShape } from 'react-intl';
import isDesktop from '../../utils/sizeHelpers';
import {
  alphabeticalSorterFor,
  chronologicalSorterFor,
} from '../shared/TableLayout';

const getFeeItemColumns = (intl: IntlShape) => {
  return [
    {
      title: intl.formatMessage({
        id: 'fleetadmin.pricing.feeitem.code',
        defaultMessage: 'ID (fee)',
      }),
      dataIndex: 'code',
      width: 150,
      fixed: 'left' as 'left',
      // render: renderText,
      sorter: alphabeticalSorterFor('code'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.pricing.feeitem.name',
        defaultMessage: 'Name (de)',
      }),
      dataIndex: 'name',
      width: 150,
      // render: renderText,
      sorter: alphabeticalSorterFor('name'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.pricing.feeitem.type',
        defaultMessage: 'Type',
      }),
      dataIndex: 'type',
      width: 150,
      // render: renderText,
      sorter: alphabeticalSorterFor('type'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.pricing.feeitem.price',
        defaultMessage: 'Amount (gross, EUR)',
      }),
      dataIndex: 'price',
      width: isDesktop() ? 200 : 150,
      // render: renderText,
      sorter: alphabeticalSorterFor('price'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.pricing.feeitem.unit',
        defaultMessage: 'Unit',
      }),
      dataIndex: 'unit',
      width: isDesktop() ? 200 : 150,
      // render: renderText,
      sorter: chronologicalSorterFor('unit'),
    },
  ];
};

export default getFeeItemColumns;
